import { ReactNode } from 'react';

type Width = 'default' | 'wide' | 'full';

const widths: Record<Width, string> = {
  default: 'max-w-7xl',
  wide: 'max-w-[1680px]',
  full: 'max-w-none',
};

/** Shared page frame so every screen uses the same gutters and max width. */
export function PageContainer({ children, width = 'default', className = '' }: { children: ReactNode; width?: Width; className?: string }) {
  return (
    <div className="min-h-screen bg-slate-50 px-4 py-6 text-slate-900 sm:px-6 lg:px-8">
      <div className={`mx-auto ${widths[width]} space-y-6 ${className}`}>{children}</div>
    </div>
  );
}

/** Shared page title row: title, optional description, and right-aligned actions. */
export function PageHeader({ title, description, actions }: { title: ReactNode; description?: ReactNode; actions?: ReactNode }) {
  return (
    <header className="flex flex-wrap items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">{title}</h1>
        {description && <p className="mt-1 text-sm text-slate-600">{description}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </header>
  );
}
